import { render, staticRenderFns } from "./DynamicSidebar.vue?vue&type=template&id=aa0c67a0&"
import script from "./DynamicSidebar.vue?vue&type=script&lang=js&"
export * from "./DynamicSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RichText: require('/opt/build/repo/storefront/components/atoms/Text/RichText.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,BaseSidebar: require('/opt/build/repo/storefront/components/molecules/Sidebar/BaseSidebar.vue').default})
